<!--
 * @Author: your name
 * @Date: 2021-06-24 23:28:45
 * @LastEditTime: 2021-07-14 18:51:04
 * @LastEditors: Please set LastEditors
 * @Description: 搜索页面
 * @FilePath: \xingmahui_front\src\views\contents\foodColumn\search.vue
-->
<template>
  <div class="history">
    <div class="header">
      <div class="search-backicon">
        <span class="goback-background" @click="goBack"></span>
      </div>
      <div class="searchBox">
        <van-search
          class="vanSearch"
          v-model="searchText"
          placeholder="开始搜索，从新妈变星妈"
          shape="round"
          maxlength="60"
          :left-icon="require('../../../assets/images/home/grey-search.png')"
          @clear="clearText"
          @search="searchKeys"
          @input="searchInput"
        />
        <span class="canBtn" @click="searchKeys">搜索</span>
      </div>
    </div>
    <div class="his" v-if="searchList && searchList.length != 0">
      <div class="his-title">
        <p class="his_icon">搜索历史</p>
        <div class="del" @click="delHander">
          <img src="../../../assets/images/icon/delete.png" />
        </div>
      </div>
      <div class="list">
        <div class="history-list">
          <div
            class="list-item"
            v-for="(item, index) in searchList"
            :key="index"
            @click="searchChange(item, 1)"
          >
            {{ item | sliceText(8) }}
          </div>
        </div>
      </div>
    </div>
    <div class="hot" v-if="hotList && hotList.length > 0">
      <div class="hot-title">
        <p class="hot_icon">热门搜索</p>
      </div>
      <div class="list">
        <div class="history-list">
          <div
            class="list-item"
            v-for="(item, index) in hotList"
            :key="index"
            @click="searchChange(item, 2)"
          >
            {{ item | sliceText(8) }}
          </div>
        </div>
      </div>
    </div></div>
</template>

<style lang="less" scoped>
.history {
  position: fixed;
  bottom: 0;
  top: 0px;
  left: 0;
  right: 0;
  background-color: #fff;
  padding-left: 12px;
  padding-top: 12px;
  z-index: 110;
  .his-title,
  .hot-title {
    padding-right: 12px;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 16px;
      font-weight: 500;
      color: @expertFontColor51;
      line-height: 1;
    }
    .del {
      width: 13px;
      height: 13px;
      img {
        width: 100%;
      }
    }
    .his_icon,
    .hot_icon {
      padding-left: 18px;
      background-position: left top;
      background-repeat: no-repeat;
      font-weight: bold;
    }
    .his_icon {
      background-image: url(../../../assets/images/icon/his.png);
      background-size: 13px 13px;
    }
    .hot_icon {
      background-image: url(../../../assets/images/icon/hot1.png);
      background-size: 11px 14px;
    }
  }
  .list {
    .history-list {
      margin-top: 12px;
      font-size: 12px;
      font-weight: 400;
      color: @expertFontColor51;
      line-height: 1;
      display: flex;
      flex-wrap: wrap;
      .list-item {
        padding: 9px 12px;
        text-align: center;
        background: @expertBorderColor242;
        border-radius: 15px;
        margin-right: 12px;
        margin-bottom: 12px;
      }
    }
  }
  .his {
    margin-bottom: 20px;
  }
  .hot {
    padding-bottom: 20px;
  }
}

.header {
  width: 355px;
  height: 34px;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.search-backicon {
  width: 20px;
  height: 3px;
  display: flex;
  align-items: center;
  justify-content: start;
  .goback-background {
    width: 9px;
    height: 16px;
    background-image: url(../../../assets/images/home/search-back.png);
    background-size: 100% 100%;
    background-position: center;
  }
}
.searchBox {
  width: 330px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .canBtn {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #d4a437;
    line-height: 14px;
  }
}
.vanSearch {
  width: 291px;
  height: 34px;
}
/deep/ .van-search {
  padding-left: 0;
  padding-right: 0;
}

/deep/ .van-field__control {
  caret-color: #d4a437;
  margin-top: 3px;
}
/deep/ .van-icon__image {
  width: 15px;
  height: 17px;
  margin-top: 6px;
}
.van-icon {
  display: block;
}
</style>

<script>
import API from "@/utils/axiosApi/searchApi";
import { uniqueArr } from "@/assets/js/common.js";
export default {
  name: "foodSearch",
  data (){
    return {
      hotList: [],
      searchText:'',
      searchList:[],
      historyVal:[],
      type: '辅食专栏'
    }
  },
  mounted(){
    // 获取搜索热词
    this.hotSearchList();
    // 获取本地搜索记录
    this.initHistory(); 
    localStorage.getItem("historyList").split(",").forEach((item) => {
      this.historyVal.push(
        item.length > 10 ? item.slice(0, 10) + "..." : item
      );
    });
    this.$nextTick(() => {
      try {
        const input = document.getElementsByClassName("van-field__control")[0];
        input.focus();
      } catch (e) {}
    });
  },
  methods:{
    uniqueArr,
    clearText(){
      sensors.track("Click_fork", {
        classification: this.type,
      });
    },
    searchKeys(){
      var historyFlag = false;
      this.historyVal.forEach((item) => {
        if (item == this.value) {
          historyFlag = true;
        }
      });
      this.searchText = this.searchText.replace(/\s*/g, "")
      if(this.searchText != "" && this.searchText.replace(/\s*/g, "") != ""){
        sensors.track("SentSearch", {
          key_word: this.searchText,
          is_history: historyFlag,
          search_number: 0,
          classification: this.type,
          is_Hot_search: false,
        });
        this.searchList.unshift(this.searchText);
        this.searchList = this.uniqueArr(this.searchList);
        localStorage.setItem("historyList", this.searchList.join(","));
        setTimeout(() => {
          this.$router.push({
            path: "/foodColumn/searchResult",
            query: {
              searchText: this.searchText,
            },
          });
        }, 200);
      }else{
        this.$toast({
          duration: 2000,
          message: "请输入关键字",
        });
      }
    },
    goBack(){
      this.$router.go(-1)
    },
    searchInput(){
      if (this.searchText.length >= 50) {
        this.searchText = this.searchText.slice(0, 50);
      }
    },
    delHander(){
      this.$dialog
        .confirm({
          message: "是否清空全部搜索记录？",
          confirmButtonText: "确定删除",
          confirmButtonColor: "#D4A437",
          cancelButtonColor: "#333",
        })
        .then(() => {
          $(".his").fadeOut(100);
          localStorage.setItem("historyList", "");
          this.searchList = [];
        })
        .catch(() => {
          // on cancel
        });
    },
    searchChange(oldtext, index){
      // 搜索内容不为空 上报数据
      if (oldtext.replace(/\s*/g, "") != "") {
        sensors.track("SentSearch", {
          key_word: oldtext,
          is_history: index === 1 ? false : true,
          search_number: 0,
          is_Hot_search: index === 1 ? false : true,
          classification: this.type,
        });
        this.$router.push({
          path: "/foodColumn/searchResult",
          query: {
            searchText: oldtext,
          },
        });
        this.searchList.unshift(oldtext);
        this.searchList = this.uniqueArr(this.searchList);
        if (this.searchList.length > 10) {
          this.searchList = this.searchList.slice(0, 10);
        }
        localStorage.setItem("historyList", this.searchList.join(","));
      }
    },
    // 获取本地搜索记录，初始化本地搜索记录
    initHistory() {
      var historyStr = "";
      if (
        localStorage.getItem("historyList") &&
        localStorage.getItem("historyList") !== ""
      ) {
        historyStr = localStorage.getItem("historyList");
      }
      if (
        localStorage.getItem("expertSearchList") &&
        localStorage.getItem("expertSearchList") !== ""
      ) {
        historyStr =
          historyStr + "," + localStorage.getItem("expertSearchList");
        localStorage.removeItem("expertSearchList");
      }
      if (
        localStorage.getItem("courseSearchList") &&
        localStorage.getItem("courseSearchList") !== ""
      ) {
        historyStr =
          historyStr + "," + localStorage.getItem("courseSearchList");
        localStorage.removeItem("courseSearchList");
      }
      localStorage.setItem("historyList", historyStr);
      historyStr.split(",").forEach((item) => {
        if (item == "") return;
        this.searchList.push(item);
      });
      if (!localStorage.getItem("historyList")) {
        $(".his-title").fadeOut(100);
      }
    },
    // 获取热词
    hotSearchList(){
      API.getSearch('recipeFoodsSearchHot', {}, (res) => {
        if (res.code == "200") {
          this.hotList = res.data;
        }
      });
    }
  },
  filters: {
    sliceText: function (text, index) {
      if (text.length > index) {
        return text.slice(0, index) + "...";
      } else {
        return text;
      }
    },
  },
}
</script>